<template>
    <b-row>

        <div class="col-sm-4 mt-3">
            <label for="" class="form-label">Sucursal</label>
            <select class="form-control form-control-sm" v-model="sucursal">
                <option value="">Seleccionar</option>
                <option v-for="(item, index) in SUCURSALES_SIN_BODEGA_CENTRAL" :key="index" :value="item.codigo">{{
                    item.nombre }}</option>
            </select>
        </div>
        <div class="col-sm-3 mt-3">
            <label for="" class="form-label">Fecha inicial</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_inicial">
        </div>
        <div class="col-sm-3 mt-3">
            <label for="" class="form-label">Fecha final</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_final">
        </div>

        <div class="col-sm-2 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="buscar_datos"><i
                    class="fas fa-search"></i> Buscar</button>
        </div>

        <div class="col-sm-12 mt-3">
            <div class="marco_control_depositos">
                <table class="table table-sm table-striped table-bordered" style="font-size: 13px;">
                    <thead>
                        <tr>
                            <th style="width: 10%;text-align: center;">
                                Fecha
                            </th>
                            <th style="width: 60%;text-align: center;">
                                No. Documento
                            </th>
                            <th style="width: 15%;text-align: center;">
                                Tipo de pago
                            </th>
                            <th style="width: 15%;text-align: center;">
                                Monto
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in registros" :key="index">
                            <td style="text-align: center;">
                                {{ item.fecha_movimiento }}
                            </td>
                            <td>
                                {{ item.dte }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.tipo_de_pago | tipo_pago }}
                            </td>
                            <td v-if="item.tipo_de_pago == 'AMBOS'" style="text-align: center;">
                                Q{{ item.dif_efectivo.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>
                            <td v-else style="text-align: center;">
                                Q{{ item.total_movimiento.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <div class="col-sm-12 mt-3">
            <div class="contenedor_total_depositos">
                TOTAL Q{{ total.toLocaleString(undefined, {
                    minimumFractionDigits: 2, maximumFractionDigits: 2
                }) }}
            </div>
        </div>
        <div class="col-sm-9 mt-3">
            <label for="" class="form-label">Número de depósito</label>
            <input type="text" class="form-control form-control-sm" v-model="no_deposito">
        </div>
        <div class="col-sm-3 mt-5">
            <button v-if="permisos['depositos.registros.congelar']?.crear || ES_ROOT" type="button"
                class="btn btn-sm btn-outline-dark btn-block" @click="enviar_registros_a_congelar"><i
                    class="fas fa-snowflake"></i>
                Congelar</button>

            <button v-else type="button" disabled class="btn btn-sm btn-outline-dark btn-block"><i
                    class="fas fa-snowflake"></i>
                Congelar</button>
        </div>
        <!-- <div class="col-sm-3 mt-5">
                    <button type="button" :disabled="btn_guardar" class="btn btn-sm btn-outline-dark btn-block"><i
                            class="fas fa-save"></i>
                        Guardar</button>
                </div> -->
    </b-row>


</template>

<script>
    import moment from 'moment'
    import { mapActions, mapGetters, mapState } from 'vuex'
    import { minix } from '../functions/alertas'
    // import Listado from './Listado.vue'
    export default {
        name: 'Descuentos',
        filters: {
            tipo_pago(val) {
                if (val == 'AMBOS') {
                    return 'EFECTIVO Y TARJETA'
                } else {
                    return val
                }
            }
        },
        computed: {
            ...mapState(['id_empresa_seleccionada', 'permisos']),
            ...mapGetters(['SUCURSALES_SIN_BODEGA_CENTRAL', 'ES_ROOT'])
        },
        components: {
            // Listado
        },
        data() {
            return {
                sucursal: '',
                fecha_inicial: moment().format('YYYY-MM-DD'),
                fecha_final: moment().format('YYYY-MM-DD'),
                no_deposito: '',
                total: 0,
                registros: [],
                btn_guardar: true
            }
        },
        methods: {
            async buscar_datos() {
                if (this.sucursal == '') {
                    minix({ icon: 'warning', mensaje: 'Selecciona una sucursal', tiempo: 3000 })
                    return
                }

                let f = {
                    api: `movimientos-cabeceras/q/obtener-registros-efectivo-para-depositos?sucursal=${this.sucursal}&fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f)
                if (r.length == 0) {
                    minix({ icon: 'warning', mensaje: 'No hay registros', tiempo: 3000 })
                    this.registros = []
                    this.sumar_montos()
                    return
                }

                this.registros = r

                this.sumar_montos()

            },
            sumar_montos() {
                let contador = 0

                for (let i = 0; i < this.registros.length; i++) {
                    const e = this.registros[i];

                    if (e.tipo_de_pago == 'AMBOS') {
                        contador += e.dif_efectivo
                    } else {
                        contador += e.total_movimiento
                    }
                }

                this.total = contador
            },
            async enviar_registros_a_congelar() {
                if (this.registros.length == 0) {
                    minix({ icon: 'warning', mensaje: 'No hay registros para congelar', tiempo: 3000 })
                    return
                }

                if (this.no_deposito == '' || this.no_deposito == null || this.no_deposito.length == 0) {
                    minix({ icon: 'warning', mensaje: 'Ingresa un número de depósito', tiempo: 3000 })
                    return
                }

                let f = {
                    api: `movimientos-cabeceras/a/congelar-depositos`,
                    formulario: {
                        no_deposito: this.no_deposito,
                        registros: this.registros,
                        empresa: this.id_empresa_seleccionada,
                        sucursal: this.sucursal
                    }
                }

                await this.guardar_data(f)
                this.sucursal = ''
                this.fecha_inicial = moment().format('YYYY-MM-DD')
                this.fecha_final = moment().format('YYYY-MM-DD')
                this.no_deposito = ''
                this.total = 0
                this.registros = []

            },
            ...mapActions(['obtener_data', 'guardar_data'])
        }
    }
</script>

<style>
    .contenedor_total_depositos {
        width: 100%;
        height: 50px;
        border-radius: 4px;
        border: 1px solid #e9e9e9;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 25px;
        font-weight: bold
    }

    .marco_control_depositos {
        width: 100%;
        height: calc(100vh - 440px);
        overflow: auto;
    }
</style>